import styled from "styled-components";

export const PredictionRow = styled.div`
  font-size: 16px;
  line-height: 19px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 20px;
`;